import { CollapsedCompanySummary } from './CollapsedCompanySummary';

import type { Company } from '@/types';
import type { FC, ReactNode } from 'react';

interface CollapsedCompanyHeaderProps {
  company: Company;
  /** Engagement stats, rendered by each dashboard in its compact form. */
  stats: ReactNode;
}

/**
 * Collapsed dashboard header: the compact company summary beside the engagement
 * stats, shared by the Ops and Partner dashboards.
 *
 * Owns both of its horizontal gutters. The header deliberately sits closer to
 * the rail than the Members block below it — 16px here against the 80px content
 * gutter — which is the approved Figma reading. Keeping both values here means
 * the offset is a self-contained pair rather than a negative margin tuned to
 * cancel a parent's padding from across a component boundary.
 */
export const CollapsedCompanyHeader: FC<CollapsedCompanyHeaderProps> = ({
  company,
  stats,
}) => (
  <div className="flex items-start gap-8 pl-4 pr-20 pt-8">
    <div className="w-80 shrink-0">
      <CollapsedCompanySummary company={company} />
    </div>
    <div className="min-w-0 flex-1">{stats}</div>
  </div>
);

export default CollapsedCompanyHeader;
